export const SET_LEARNING_RESULTS = 'viewer/learning_results/SET_LEARNING_RESULTS';
export const SET_LEARNING_RESULT = 'viewer/learning_results/SET_LEARNING_RESULT';
export const SET_CLASS_RANKS = 'viewer/quiz_results/SET_CLASS_RANKS';
export const SET_ALL_RANKS = 'viewer/quiz_results/SET_ALL_RANKS';
export const SHOW_FORCE_RESULT = 'viewer/quiz_results/SHOW_FORCE_RESULT';
export const SET_LEARNING_RESULT_STATS = 'viewer/learning_results/SET_LEARNING_RESULT_STATS';
